/**
 * For deep inspection
 */
 import elevators from 'config/elevators.json';
 import BinaryHeap from 'utils/binaryHeap';
 import { calculateGCostOfPath, setupAndSearch } from 'utils/searchPath';
 import switchMapInfoSet from 'utils/switchMapInfo';
 
 
 

 const notNull = testId => {
  return testId !== null;
};
 // take the g (gCost) as param to derive the shortest path
 function getHeap() {
   return new BinaryHeap(function (node) {
     return node.gCost;
   });
 };
 
 
 // gCost of all paths lead to possible elevators/escalators
 /**
  * 
  * @param {number} deviceSvgId 
  * @param {number} deviceFloor 
  * @param {array} facility
  */
 export const searchNearestFacility = (deviceSvgId, deviceFloor, facility) => {
   const {vertices, connections} = switchMapInfoSet(deviceFloor);
   
   const sortedHeap = getHeap();
    
    
   facility.forEach(destination => {
    const destinationSvgId = destination;
    const path = setupAndSearch(connections, vertices, deviceSvgId, destinationSvgId);
    const gCostOfPath = calculateGCostOfPath(path);
    const heapItem = {
    id: destinationSvgId,
    gCost: gCostOfPath
    };
    
    console.log("heapItem",heapItem)
    sortedHeap.push(heapItem);
   });
 
   return sortedHeap.pop();
 };

 const searchRelevantEles = (floorStart, floorDestination) => {
  const result = elevators.filter(item => (
    notNull(item.svgIdOnFloor[floorStart]) && notNull(item.svgIdOnFloor[floorDestination])
  ));
  return result;
};

 /**
 * 
 * @param {number} deviceSvgId 
 * @param {number} deviceFloor 
 * @param {number} floorDestination
 */
export const searchNearestCommutation = (deviceSvgId, deviceFloor, floorDestination) => {
  const {vertices, connections} = switchMapInfoSet(deviceFloor);
  const availElevators = searchRelevantEles(deviceFloor, floorDestination);
  const sortedHeap = getHeap();

  availElevators.forEach(destination => {
    const destinationSvgId = destination.svgIdOnFloor[deviceFloor];
    const path = setupAndSearch(connections, vertices, deviceSvgId, destinationSvgId);
    const gCostOfPath = calculateGCostOfPath(path);
    const heapItem = {
      id: destination.id,
      gCost: gCostOfPath
    };

    sortedHeap.push(heapItem);
  });

  return sortedHeap.pop();
};

 